import React from 'react';
import Children from '../../interfaces/children.interface';
import ClassName from '../../interfaces/class-name.interface';
import Color from '../../interfaces/color.interface';
import Gap from '../../interfaces/gap.interface';
import Layer from '../../interfaces/layer.interface';
import Size from '../../interfaces/size.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props extends Children, ClassName, Color, Gap, Layer, Size, TestId {
  /** The text alignment */
  align?: 'inherit' | 'left' | 'right' | 'center';

  /** Optionally render a different HTML element (default: p) */
  as?: string;
}

/** Renders any kind of text */
const Text = ({
  align = 'inherit',
  as = 'p',
  children,
  className = '',
  color = 'inherit',
  gap = 'none',
  layer = 0,
  size = 'inherit',
  testId,
}: Props): React.ReactElement =>
  React.createElement(
    as,
    {
      className: `
    gap--${gap}
    layer--${layer}
    ${align !== 'inherit' ? `text-${align}` : ''}
    skeletonize
    text-${color}
    text-${size}
    ${className}
  `,
      'data-testid': testId,
    },
    children
  );

export default Text;
